<mat-card appearance="outlined">
  <section>
    <div class="flex flex-row gap-6 my-8" style="font-size:larger">
      <h3>Administration</h3>
    </div>
  </section>
  <section>
    <mat-tab-group dynamicHeight [(selectedIndex)]="adminService.currentTab">

      <mat-tab label="Manage Master Tables" *ngIf="tabVisible('masterTables')">
        <app-masterTables></app-masterTables>
      </mat-tab>

      <mat-tab label="Upload PT" *ngIf="tabVisible('pt')">
        <app-uploadPt></app-uploadPt>
      </mat-tab>

      <mat-tab label="View PT reports" *ngIf="tabVisible('ptReports')">
        <app-ptReports></app-ptReports>
      </mat-tab>

      <mat-tab label="Permit/License Manager" *ngIf="tabVisible('registrationLicense')">
        <app-registrationLicense></app-registrationLicense>
      </mat-tab>

    </mat-tab-group>
  </section>
</mat-card>